export const moodle = state => state.adminReducer.moodle.moodle

export const isLoading = state => state.adminReducer.moodle.isLoading

export const isSuccess = state => state.adminReducer.moodle.isSuccess

export const error = state => state.adminReducer.moodle.error

export const permissions = state => state.adminReducer.moodle.permissions
